import { Home } from 'pages/Home/Home';

export default Home;